import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip } from 'antd';
import clsx from 'clsx';

import {
	actionSingleEmployees,
	actionEmployeesDeleteClaims,
	actionEmployeesSetClaims,
} from '../../redux/action/accessRights/actionUsersList';

import { actionGetRolesRights } from '../../redux/action/accessRights/actionRoles';

import { reducerUsersClaims } from '../../redux/reducer/accessRights/reducers/usersList';

import { AppDispatch } from '../../redux/reducer/store';

import Blackout from '../custom/blackout/blackout';
import EditClaimDescriptionModal from '../editClaimDescriptionModal/editClaimDescriptionModal';

import { ReactComponent as DirectionIcon } from '../../assets/icons/direction.svg';
import { ReactComponent as QuestionIcon } from '../../assets/icons/question.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import Close from '../../assets/icons/close.svg';

import styles from './rolesModal.module.scss';

interface IProps {
	claims: number;
	title: string;
	onClose: any;
	id: any;
}

const claimsList = [
	{ role: { id: 1, name: "Администратор" } },
	{ role: { id: 2, name: "Отчеты: Просмотр списка отчетов" } },
	{ role: { id: 3, name: "Отчеты: Просмотр оценки отчетов" } },
	{ role: { id: 4, name: "Отчеты: Оценка отчета" } },
	{ role: { id: 5, name: "Отчеты: Внутренняя проверка отчета" } },
	{ role: { id: 6, name: "Отчеты: Редактирование отчета" } },
	{ role: { id: 7, name: "Отчеты: Удаление отчета" } },
	{ role: { id: 8, name: "Отчеты: Копирование отчета" } },
	{ role: { id: 9, name: "Тандер: Просмотр списка сигналов" } },
	{ role: { id: 10, name: "Тандер: Настройки тандера" } },
	{ role: { id: 11, name: "Easy Merch: Просмотр Easy Merch модуля" } },
	{ role: { id: 12, name: "Не сданные отчеты: Удаление несданных отчетов" } },
	{ role: { id: 13, name: "Не сданные отчеты: Просмотр несданных отчетов" } },
	{ role: { id: 14, name: "Отчеты: Обновление статуса проверки" } },
	{ role: { id: 15, name: "Права доступа: Изменение прав доступа" } },
	{ role: { id: 16, name: "Набор персонала: Анкеты: Списка анкет" } },
	{ role: { id: 17, name: "Набор персонала: Анкеты: Создание новой анкеты" } },
	{ role: { id: 18, name: "Набор персонала: Анкеты: Удаление анкеты" } },
	{ role: { id: 19, name: "Набор персонала: Анкеты: Редактирование анкеты" } },
	{ role: { id: 20, name: "Набор персонала: Анкеты: Выгрузка: Выбор вакансии для анкеты" } },
	{ role: { id: 21, name: "Набор персонала: Анкеты: Выгрузка: Статистика по кандидатам" } },
	{ role: { id: 22, name: "Набор персонала: Анкеты: Выгрузка: Отчет по вакансиям через анкеты" } },
	{ role: { id: 23, name: "Набор персонала: Анкеты: Выгрузка: Список анкет" } },
	{ role: { id: 24, name: "Набор персонала: Вакансии: Список вакансий" } },
	{ role: { id: 25, name: "Набор персонала: Вакансии: Редактирование вакансий" } },
	{ role: { id: 26, name: "Набор персонала: Вакансии: Редактирование статуса вакансии" } },
	{ role: { id: 27, name: "Проекты: Список проектов" } },
	{ role: { id: 28, name: "Проекты: Список маршрутов" } },
	{ role: { id: 29, name: "Права доступа: Просмотр списка клиентов" } },
	{ role: { id: 30, name: "Права доступа: Удаление клиента" } },
	{ role: { id: 31, name: "Права доступа: Создание клиента" } },
	{ role: { id: 32, name: "Права доступа: Редактирование клиента в списке" } },
	{ role: { id: 33, name: "Несданные отчеты: Просмотр списка" } },
	{ role: { id: 34, name: "Несданные отчеты: Удаление отчета" } },
	{ role: { id: 35, name: "Несданные отчеты: Создание отчета" } },
	{ role: { id: 36, name: "Несданные отчеты: Выгрузка" } },
	{ role: { id: 37, name: "Отчеты: Создание геолокации" } },
	{ role: { id: 39, name: "Права доступа: Редактирование клиента в карточке" } },
	{ role: { id: 40, name: "Выгрузки: Cron" } },
	{ role: { id: 41, name: "Выгрузки: Zip" } },
	{ role: { id: 42, name: "Выгрузки: Excel" } },
	{ role: { id: 43, name: "Выгрузки: Табеля" } },
	{ role: { id: 44, name: "Набор персонала: Вакансии: Выгрузка списка вакансий" } },
	{ role: { id: 46, name: "Отчеты: Обновление статуса оценки" } },
	{ role: { id: 48, name: "Отчеты: Обновление статуса доставки" } },
	{ role: { id: 84, name: "Табеля: Просмотр списка" } },
	{ role: { id: 137, name: "Отчеты: Загрузка шаблона EasyMerch" } },
	{ role: { id: 138, name: "Выгрузки: Импорт файлов" } },
	{ role: { id: 139, name: "Отчеты: Загрузка шаблона KPI" } },
	{ role: { id: 140, name: "Изменение сотрудника" } },
	{ role: { id: 141, name: "Список сотрудников" } },
	{ role: { id: 142, name: "Удаление сотрудника" } }
];

const RolesEmployeesModal: FC<IProps> = ({ onClose, title, id }) => {
	const dispatch = useDispatch<AppDispatch>();
	const { activeClaimsList, rolesList } = useSelector((state: any) => state.roles.usersList);
	const { roleRights, allRolesRights } = useSelector(
		(state: any) => state.roles.roles
	);
	const { claims } = useSelector((state: any) => state.user.user.data);

	const [selectedUsedRoles, setSelectedUsedRoles] = useState<number[]>([]);
	const [selectedAllRoles, setSelectedAllRoles] = useState<number[]>([]);
	const [usedRolesSearch, setUsedRolesSearch] = useState<string>('');
	const [allRolesSearch, setAllRolesSearch] = useState<string>('');
	const [isEditOpen, setIsEditOpen] = useState(false);
	const [currentElem, setCurrentElem] = useState(null);
	const [useData, setUserData] = useState(null);
	const [allClaimsList, setAllClaimsList] = useState(claimsList);

	const filteredUsedRoles =
		activeClaimsList &&
		activeClaimsList?.filter((option: any) =>
			option?.role.name
				?.toLowerCase()
				?.includes(usedRolesSearch?.toLowerCase())
		);

	const filteredAllRoles =
		allRolesRights &&
		allRolesRights?.filter((option: any) =>
			option?.role.name?.toLowerCase()?.includes(allRolesSearch?.toLowerCase())
		);
		console.log(activeClaimsList, filteredUsedRoles);

	useEffect(() => {
		dispatch(actionSingleEmployees(id)).then((data) => {
			setUserData(data);
			const foundRole = rolesList.find((el: any) => el.role.name === Object.values(data.role).toString());
			dispatch(actionGetRolesRights(foundRole.role.id));
		})
		// eslint-disable-next-line
	}, [dispatch, id]);

	useEffect(() => {
		dispatch(reducerUsersClaims(roleRights))
		// eslint-disable-next-line
	}, [roleRights])

	const handleAllRoleClick = (roleId: number) => {
		if (selectedAllRoles.includes(roleId)) {
			setSelectedAllRoles(selectedAllRoles.filter(id => id !== roleId));
		} else {
			setSelectedAllRoles([...selectedAllRoles, roleId]);
		}
	};

	const handleUsedRoleClick = (roleId: number) => {
		if (selectedUsedRoles.includes(roleId)) {
			setSelectedUsedRoles(selectedUsedRoles.filter(id => id !== roleId));
		} else {
			setSelectedUsedRoles([...selectedUsedRoles, roleId]);
		}
	};

	const handleAddSelectedRoles = () => {
		if (selectedAllRoles.length > 0) {
			const filteredRoles = claimsList
				.filter((roleObj: any) => selectedAllRoles.includes(roleObj.role.id))
				.map((elem: any) => elem);
			const rolesId = filteredRoles.map((obj: any) => obj.role.id)
			const filteredAllRoles = allClaimsList
				.filter((roleObj: any) => !rolesId.includes(roleObj.role.id))
			setAllClaimsList(filteredAllRoles);
			console.log(filteredRoles, rolesId, filteredAllRoles);

			dispatch(actionEmployeesSetClaims(id, filteredRoles));
			setSelectedAllRoles([]);
		}
	};

	const handleDeleteSelectedRoles = () => {
		if (selectedUsedRoles.length > 0) {
			const filteredRoles = activeClaimsList
				.filter((roleObj: any) => selectedUsedRoles.includes(roleObj.id))
				.map((elem: any) => elem);

			const rolesId = filteredRoles.map((obj: any) => obj.id)
			const filteredAllRoles = allClaimsList
				.filter((roleObj: any) => !rolesId.includes(roleObj.id))
			setAllClaimsList(filteredAllRoles);
			dispatch(actionEmployeesDeleteClaims(useData, filteredRoles));
			setSelectedUsedRoles([]);
		}
	};

	const handleClickTooltip = (event: any) => {
		event.stopPropagation();
	};

	const handleEditClaimDescription = (elem: any) => {
		setCurrentElem(elem);

		setIsEditOpen(!isEditOpen);
	};

	const handleClose = ()=> {
		dispatch(reducerUsersClaims([]));
		onClose();
	}

	return (
		<>
			<Blackout onClose={handleClose}>
				<div
					onClick={(event: any) => event.stopPropagation()}
					className={styles.modal}
				>
					<div className={styles.title__block}>
						<span>{title}</span>
						<img
							style={{ cursor: 'pointer' }}
							onClick={onClose}
							src={Close}
							alt='close'
						/>
					</div>
					<div className={styles.roles__block}>
						<div className={styles.button__block}>
							<div className={styles.roles__table}>
								<div className={styles.roles__title_block}>
									<span>Доступные права</span>
								</div>
								<input
									onChange={e => setAllRolesSearch(e?.target?.value)}
									className={styles.roles__search}
									placeholder='Поиск...'
									type='text'
								/>
								<div className={styles.roles__list}>
									{filteredAllRoles &&
										filteredAllRoles.map((elem: any, index: number) => (
											<div
												onClick={() => handleAllRoleClick(elem.role.id)}
												className={clsx(
													styles.role__elem,
													selectedAllRoles.includes(elem.role.id) &&
													styles.active__role
												)}
												key={index}
											>
												<span>{elem.role.name}</span>

												<Tooltip
													title={
														<div
															className={styles.tooltip__block}
															onClick={handleClickTooltip}
														>
															<div
																className={styles.tooltip__text}
																dangerouslySetInnerHTML={{
																	__html: elem.description,
																}}
															/>
															{(claims.includes('admin') ||
																claims.includes('role:claim:change')) && (
																	<EditIcon
																		onClick={() =>
																			handleEditClaimDescription(elem)
																		}
																		className={styles.edit__icon}
																	/>
																)}
														</div>
													}
													color={'var(--main-color)'}
													placement='right'
												>
													<QuestionIcon
														className={clsx(
															styles.role__elem_icon,
															selectedAllRoles.includes(elem.id) &&
															styles.active__role_icon
														)}
													/>
												</Tooltip>
											</div>
										))}
								</div>
							</div>
							<button
								disabled={
									!(
										claims.includes('admin') ||
										claims.includes('role:claim:change')
									)
								}
								className={clsx(
									styles.add__table_disabledButton,
									selectedAllRoles.length > 0 &&
									(claims.includes('admin') ||
										claims.includes('role:claim:change')) &&
									styles.add__table_activeButton
								)}
								onClick={handleAddSelectedRoles}
							>
								Добавить выбранные
								<DirectionIcon className={styles.add__direction_icon} />
							</button>
						</div>

						<div className={styles.button__block}>
							<div className={styles.roles__table}>
								<div className={styles.roles__title_block}>
									<span>Назначенные права</span>
								</div>
								<input
									onChange={e => setUsedRolesSearch(e?.target?.value)}
									className={styles.roles__search}
									placeholder='Поиск...'
									type='text'
								/>
								<div className={styles.roles__list}>
									{filteredUsedRoles &&
										filteredUsedRoles.map((elem: any, index: number) => (
											<div
												onClick={() => handleUsedRoleClick(elem.role.id)}
												className={clsx(
													styles.role__elem,
													selectedUsedRoles.includes(elem.role.id) &&
													styles.active__role
												)}
												key={index}
											>
												<span>{elem.role.name}</span>
												<Tooltip
													title={
														<div
															className={styles.tooltip__block}
															onClick={handleClickTooltip}
														>
															<div
																className={styles.tooltip__text}
																dangerouslySetInnerHTML={{
																	__html: elem.description,
																}}
															/>

															{(claims.includes('admin') ||
																claims.includes('role:claim:change')) && (
																	<EditIcon
																		onClick={() =>
																			handleEditClaimDescription(elem)
																		}
																		className={styles.edit__icon}
																	/>
																)}
														</div>
													}
													color={'var(--main-color)'}
													placement='right'
												>
													<QuestionIcon
														className={clsx(
															styles.role__elem_icon,
															selectedUsedRoles.includes(elem.id) &&
															styles.active__role_icon
														)}
													/>
												</Tooltip>
											</div>
										))}
									{!filteredUsedRoles && (
										<span className={styles.empty__list_text}>
											Нет назначенных прав
										</span>
									)}
								</div>
							</div>
							<button
								disabled={
									!(
										claims.includes('admin') ||
										claims.includes('role:claim:change')
									)
								}
								className={clsx(
									styles.delete__table_disabledButton,
									selectedUsedRoles.length > 0 &&
									(claims.includes('admin') ||
										claims.includes('role:claim:change')) &&
									styles.delete__table_activeButton
								)}
								onClick={handleDeleteSelectedRoles}
							>
								<DirectionIcon className={styles.delete__direction_icon} />
								Удалить выбранные
							</button>
						</div>
					</div>
				</div>
			</Blackout>
			{isEditOpen && (
				<EditClaimDescriptionModal
					setState={setIsEditOpen}
					state={isEditOpen}
					id={id}
					elem={currentElem}
				/>
			)}
		</>
	);
};

export default RolesEmployeesModal;
